//@flow
import React from "react"
import { FormattedMessage } from "react-intl"
import moment from "moment"
import { Layer } from "../UI/Page"
import { Flex, Box } from "grid-styled"
import { SearchListView } from "../SearchTableView"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityPrimaryLink,
  EntityAction
} from "../UI/EntityList"
import { H2 } from "../UI/Headings"
import { queries } from "../Kiosks"
import type { KioskListQuery } from "../Kiosks"

type SectionProps = {
  push: Function
}

type KioskListProps = {
  kiosks: KioskListQuery,
  handleSearch: Function,
  searchName: string,
  push: Function
}

const KioskList = ({
  kiosks: { kiosks, loading },
  handleSearch,
  searchName,
  push
}: KioskListProps) => (
  <SearchListView
    handleSearch={handleSearch}
    searchName={searchName}
    query={searchName}
    entityName="Kiosks"
    loading={loading}
  >
    <EntityHeading>
      <EntityDetail grow={2}>Name</EntityDetail>
      <EntityDetail grow={1}>Starts</EntityDetail>
      <EntityDetail grow={1}>Expires</EntityDetail>
      <EntityDetail grow={1} shrink={0} />
    </EntityHeading>
    {kiosks &&
      kiosks.map(kiosk => (
        <Entity key={kiosk.id}>
          <EntityDetail grow={2}>
            <EntityPrimaryLink to={`/admin/kiosks/${kiosk.id || "new"}`}>
              {kiosk.friendlyName || kiosk.id}
            </EntityPrimaryLink>
          </EntityDetail>
          <EntityDetail grow={1}>
            {moment(kiosk.startsAt).format("M-D-YYYY")}
          </EntityDetail>
          <EntityDetail grow={1}>
            {moment(kiosk.endsAt).format("M-D-YYYY")}
          </EntityDetail>
          <EntityDetail grow={1} shrink={0} row end>
            <EntityAction
              href="#"
              onClick={() => push(`/admin/kiosks/${kiosk.id || "new"}`)}
              icon="✏️"
            />
          </EntityDetail>
        </Entity>
      ))}
  </SearchListView>
)

const KioskListWithData = queries.withKiosks(KioskList)
type State = { query: string }

class KiosksSection extends React.Component<SectionProps, State> {
  props: SectionProps

  constructor(props: SectionProps) {
    super(props)
    this.state = { query: "" }
  }

  handleSearch = (query: string) => this.setState(() => ({ query }))

  render() {
    const { push } = this.props
    const { query } = this.state

    return (
      <Layer>
        <Flex w="100%" wrap>
          <Box w={[1, 1 / 2, 1 / 3, null]} pr={[0, 2]}>
            <H2>
              <FormattedMessage id="admin.dashboard.kiosks.title" />
            </H2>
            <p>
              <FormattedMessage id="admin.dashboard.kiosks.description" />
            </p>
          </Box>
          <Box w={[1, 1 / 2, 2 / 3]}>
            <KioskListWithData
              push={push}
              searchName={query}
              handleSearch={this.handleSearch}
            />
          </Box>
        </Flex>
      </Layer>
    )
  }
}

export default KiosksSection



// WEBPACK FOOTER //
// ./src/Home/KiosksSection.js